/* eslint-disable array-callback-return */
import './style.css';

import { Skeleton } from 'antd';
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import Countdown from 'react-countdown';
import { useAccount } from 'wagmi';
import web3 from 'web3';

import { useWeb3ModalState } from '@web3modal/wagmi/react';

import { AppHome } from '../../../../api/appHome';
import { Noti } from '../../../../components/Noti/toast';
import { BASE_SCAN, WORK_CHAIN } from '../../../../constants';
import { useContract } from '../../../../hooks/useContract';
import { formatNumber } from '../../staking/details/utils';
import { convertDateToString } from '../utils';
import abiVestingHMC from '../utils/abiVestingHMC.json';
import { useHookVestingHMC } from './storeVesting';
import { HISTORY_TYPE } from '../../../../constants/enums';
import { formatEther } from 'viem';
import { useContractViem } from '../../../../hooks/useContractViem';

const Vesting = () => {
  const { selectedNetworkId }: any = useWeb3ModalState();
  const { address } = useAccount();
  const [state, actions] = useHookVestingHMC();
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(true);
  const [isClaimed, setIsClaimed] = useState(false);
  const [unlockedToken, setUnlockedToken]: any = useState(0);
  const [totalToken, setTotalToken]: any = useState(0);
  const [totalClaimed, setTotalClaimed]: any = useState(0);
  const [dataContract, setDataContract]: any = useState();
  const [startClaimTemp, setStartClaimTemp]: any = useState(0);
  const [cliffTemp, setCliffTemp]: any = useState(0);
  const [timePerPeriod, setTimePerPeriod]: any = useState(0);
  const [totalPeriods, setTotalPeriods]: any = useState(0);
  const [disableWithdraw, setDisableWithdraw]: any = useState(true);
  const [reCheck, setReCheck]: any = useState(false);
  const [timeNextClaim, setTimeNextClaim]: any = useState(0);
  // const [listHis, setListHis]: any = useState([])
  let sc_vesting = dataContract && dataContract?.user_vesting_hmc_may_contract;
  const vestingContract: any = useContract(sc_vesting, abiVestingHMC);

  const vestingContractViem = useContractViem(sc_vesting, abiVestingHMC);

  const rendererCountDownVesting = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: any) => {
    // Render a countdown
    if (completed) {
      setTimeout(() => {
        window.location.reload();
        return <span className="text-cd-vest">Withdrawable</span>;
      }, 1000);
    }
    if (days > 1) {
      return (
        <span className="text-cd-vest">
          {days}d : {hours}h : {minutes}m
        </span>
      );
    } else if (days === 1) {
      return (
        <span className="text-cd-vest">
          {days}d : {hours}h : {minutes}m
        </span>
      );
    } else {
      return (
        <span className="text-cd-vest">
          {hours}h : {minutes}m : {seconds}s
        </span>
      );
    }
  };

  const SettingContract = async () => {
    try {
      let res = await AppHome.getSettingContract();
      if (res.data.success === true) {
        setDataContract(res.data.data);
      }
    } catch (error) {
      console.log('Error: ', error);
    }
  };

  useEffect(() => {
    SettingContract();
  }, []);

  const getUnlockedToken = async () => {
    try {
      if (address && vestingContractViem) {
        const rsUnlockTokens = await vestingContractViem.read.claimAble([
          address,
        ]);
        console.log('run----------------------------------', rsUnlockTokens);
        if (
          rsUnlockTokens !== null &&
          (rsUnlockTokens !== undefined) !== null &&
          rsUnlockTokens !== undefined
        ) {
          console.log(
            'run 1----------------------------------',
            Number(formatEther(rsUnlockTokens))
          );

          setUnlockedToken(Number(formatEther(rsUnlockTokens)));
        }
      }
      // await vestingContract
      //   .claimAble(address)
      //   .then((res: any) => {
      //     console.log(
      //       'get unlockedToken---------------------------',
      //       address,
      //       formatEther(res)
      //     );
      //     let temp: any = web3.utils.fromWei(res, 'ether');
      //     setUnlockedToken(Number(temp));
      //   })
      //   .catch((err: any) => {
      //     setUnlockedToken(0);
      //     console.log('err claimAble', err);
      //   });
    } catch (error) {
      console.log('error-------------------', error);
      setUnlockedToken(0);
    }
  };

  const [firstRelease, setFirstRelease]: any = useState();
  const getFirstRelease = async () => {
    try {
      // const rsGetFirstRelease = await vestingContractViem.read.firstRelease();
      // if (rsGetFirstRelease) {
      //   setFirstRelease(Number(rsGetFirstRelease));
      // }
      await vestingContract
        .firstRelease()
        .then((res: any) => {
          setFirstRelease(Number(res));
        })
        .catch((err: any) => {
          setFirstRelease(0);
          console.log('err firstRelease', err);
        });
    } catch (error) {
      setFirstRelease(0);
      console.log('error firstRelease', error);
    }
  };

  useEffect(() => {
    if (
      address &&
      selectedNetworkId === WORK_CHAIN &&
      vestingContract !== null
    ) {
      getFirstRelease();
    } else {
      setFirstRelease(0);
    }
  }, [address, selectedNetworkId, vestingContract]);

  const getUserInfo = async () => {
    try {
      const rsUserInfo = await vestingContractViem.read.userInfo([address]);
      if (rsUserInfo && rsUserInfo.length) {
        let amount: any = formatEther(rsUserInfo[0]);
        let tokensClaimed: any = formatEther(rsUserInfo[1]);
        setTotalToken(Number(amount));
        setTotalClaimed(tokensClaimed);
        setLoading1(false);
      }

      // await vestingContract
      //   .userInfo(address)
      //   .then((res: any) => {
      //     let amount: any = web3.utils.fromWei(res[0], 'ether');
      //     let tokensClaimed: any = web3.utils.fromWei(res[1], 'ether');
      //     console.log('sc-------------------------', sc_vesting);
      //     setTotalToken(Number(amount));
      //     setTotalClaimed(tokensClaimed);
      //     setLoading1(false);
      //   })
      //   .catch((err: any) => {
      //     setTotalToken(0);
      //     setTotalClaimed(0);
      //     console.log('err userInfo', err);
      //     setLoading1(false);
      //   });
    } catch (error) {
      console.log('error userInfo', error);
      setTotalToken(0);
      setTotalClaimed(0);
      setLoading1(false);
    }
  };

  useEffect(() => {
    let timer = setTimeout(() => {
      if (!address) {
        setLoading1(false);
      }
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [address]);

  useEffect(() => {
    if (
      address &&
      selectedNetworkId === WORK_CHAIN &&
      vestingContract !== null
    ) {
      getUserInfo();
      getUnlockedToken();
    } else {
      setTotalToken(0);
      setTotalClaimed(0);
      setUnlockedToken(0);
    }
  }, [address, selectedNetworkId, vestingContract]);

  const getStartTime = async () => {
    try {
      // const rsStartTime = await vestingContractViem.read.startTime();
      // if (rsStartTime) {
      //   setStartClaimTemp(Number(rsStartTime || 0));
      // }
      await vestingContract
        .startTime()
        .then((res: any) => {
          setStartClaimTemp(res?.toString());
        })
        .catch((err: any) => {
          setStartClaimTemp(0);
          console.log('err startTime', err);
        });
    } catch (error) {
      setStartClaimTemp(0);
      console.log('error startTime', error);
    }
  };

  const getCliff = async () => {
    try {
      // const rsCliff = await vestingContractViem.read.cliff();
      // if (rsCliff) {
      //   setStartClaimTemp(Number(rsCliff || 0));
      // }
      await vestingContract
        .cliff()
        .then((res: any) => {
          setCliffTemp(res?.toString());
        })
        .catch((err: any) => {
          setCliffTemp(0);
          console.log('err cliffTemp', err);
        });
    } catch (error) {
      setCliffTemp(0);
      console.log('error cliffTemp', error);
    }
  };

  const getTimePerPeriod = async () => {
    try {
      // const rsTimePerPeriod = await vestingContractViem.read.timePerPeriod();
      // if (rsTimePerPeriod) {
      //   setTimePerPeriod(Number(rsTimePerPeriod || 0));
      // }
      await vestingContract
        .timePerPeriod()
        .then((res: any) => {
          setTimePerPeriod(res?.toString());
        })
        .catch((err: any) => {
          setTimePerPeriod(0);
          console.log('err cliffTemp', err);
        });
    } catch (error) {
      setTimePerPeriod(0);
      console.log('error cliffTemp', error);
    }
  };

  const getTotalPeriods = async () => {
    try {
      // const rsTotalPeriods = await vestingContractViem.read.totalPeriods();
      // if (rsTotalPeriods) {
      //   setTotalPeriods(Number(rsTotalPeriods || 0));
      // }
      await vestingContract
        .totalPeriods()
        .then((res: any) => {
          setTotalPeriods(res?.toString());
        })
        .catch((err: any) => {
          setTotalPeriods(0);
          console.log('err cliffTemp', err);
        });
    } catch (error) {
      setTotalPeriods(0);
      console.log('error cliffTemp', error);
    }
  };

  useEffect(() => {
    if (selectedNetworkId === WORK_CHAIN && vestingContract !== null) {
      getStartTime();
      getCliff();
      getTimePerPeriod();
      getTotalPeriods();
      getUserInfo();
      getUnlockedToken();
    }
  }, [selectedNetworkId, reCheck, vestingContract]);

  useEffect(() => {
    if (startClaimTemp * 1000 > Date.now()) {
      setDisableWithdraw(true);
    } else {
      setDisableWithdraw(false);
    }
  }, [startClaimTemp]);

  const btnWithdrawAll = () => {
    const obj = {
      className: `ac-wd`,
      disabled: loading || isClaimed || disableWithdraw || unlockedToken <= 0,
    };
    return obj;
  };

  const viewContract = () => {
    window.open(`${BASE_SCAN}/address/${sc_vesting}`);
  };

  let currentTime = Date.now();
  let startClaimMilis = startClaimTemp * 1000;
  let perPeriodMilis = timePerPeriod * 1000;
  let totalStartCliff = startClaimTemp * 1000 + cliffTemp * 1000;
  let numberLoop = 1000;

  const caculaCountDown = () => {
    for (let i = 0; i <= numberLoop; i++) {
      if (
        currentTime >= totalStartCliff + perPeriodMilis * i &&
        currentTime < totalStartCliff + perPeriodMilis * (i + 1)
      ) {
        setTimeNextClaim(totalStartCliff + perPeriodMilis * (i + 1));
        break;
      } else {
        if (i === numberLoop) {
          setTimeNextClaim(0);
        }
      }
    }
  };

  useEffect(() => {
    if (
      Number(totalToken) === Number(totalClaimed) ||
      currentTime >= totalStartCliff + perPeriodMilis * Number(totalPeriods - 1)
    ) {
      setTimeNextClaim(0);
    } else {
      // chưa tới giờ claim ở TGE
      if (startClaimMilis > currentTime) {
        setTimeNextClaim(startClaimMilis);
      }
      // đã claim lần đầu ở TGE. chờ tới lần claim vesting lần thứ 1
      else if (
        startClaimMilis <= currentTime &&
        currentTime < totalStartCliff
      ) {
        setTimeNextClaim(totalStartCliff);
      } else {
        caculaCountDown();
      }
    }
  }, [
    startClaimTemp,
    reCheck,
    totalClaimed,
    totalPeriods,
    totalToken,
    cliffTemp,
    timePerPeriod,
  ]);

  const addHis = async (hash: any, amount: any, type: any) => {
    try {
      let params = {
        ownerAddress: address,
        contractAddress: sc_vesting,
        txHash: hash,
        amount: amount,
        type: type,
        assetToken: 'Mey',
      };
      await actions.addHistory(params);
    } catch (error) {}
  };

  const claim = async () => {
    try {
      setLoading(true);
      await vestingContract
        .claimTokens()
        .then((res: any) => {
          res.wait().then(async (resWait: any) => {
            console.log(
              'status claim tokens-----------------------',
              resWait?.status,
              resWait?.status === 1
            );
            if (resWait?.status === 1) {
              console.log('Claim tokens as history-----------------------');
              await addHis(
                resWait?.transactionHash,
                unlockedToken,
                HISTORY_TYPE.VESTING_HMC
              );
              setTimeout(() => {
                setReCheck(!reCheck);
                setLoading(false);
                setIsClaimed(true);
                Noti('success', 'Withdraw successfully', 3000);
              }, 1000);
            } else {
              Noti('error', 'Hash fail', 3000);
              setLoading(false);
            }
          });
        })
        .catch((error: any) => {
          // console.log('error1', error)
          console.log('message', error?.reason);
          setLoading(false);
          if (error?.code) {
            Noti('error', error?.reason || error.code || 'Unknown error', 3000);
          } else {
            Noti('error', error || 'Unknown error', 3000);
          }
        });
      await getUnlockedToken();
    } catch (error: any) {
      console.log('error222', error);
      setLoading(false);
      if (error.code) {
        Noti('error', error.code || 'Unknown error', 3000);
      } else {
        Noti('error', error || 'Unknown error', 3000);
      }
    }
  };

  // const getHis = async () => {
  //     try {
  //         let params = {
  //             ownerAddress: address,
  //             pageSize: 10,
  //             pageIndex: 0
  //         }
  //         await actions.getHistory(params).then((res: any) => {
  //             setListHis(res)
  //         })
  //             .catch((err: any) => {
  //                 console.log('err', err)
  //                 setListHis([])
  //             })
  //     } catch (error) {
  //         setListHis([])
  //     }
  // }

  // useEffect(() => {
  //     if (address) {
  //         getHis()
  //     }
  // }, [address, reCheck])

  // let firstRe = (firstRelease * totalToken) / 10000

  let firstRe = firstRelease / 100;

  let arr = new Array(Number(totalPeriods) + 1).fill(0);
  let arrvesting: any = [];

  arr.map((item: any, index: any) => {
    if (index === 0) {
      let checkClaim: any;
      if (Date.now() >= Number(startClaimTemp) * 1000) {
        if (Number(totalClaimed) >= (totalToken * firstRe) / 100) {
          checkClaim = 'Withdrawn';
        } else {
          checkClaim = 'UnLocked';
        }
      } else {
        checkClaim = 'Locked';
      }
      let obj = {
        day: convertDateToString(startClaimTemp),
        por: formatNumber(firstRe, 4),
        /// 100 / (Number(totalPeriods) + 1),
        amount: formatNumber((totalToken * firstRe) / 100, 4),
        // totalToken / (Number(totalPeriods) + 1),
        asset: 'MEY',
        status: checkClaim,
      };

      arrvesting.push(obj);
    } else if (index === 1) {
      let checkClaim: any;
      if (Date.now() >= Number(startClaimTemp) * 1000) {
        if (
          Number(totalClaimed) >=
          (totalToken * ((100 - firstRe) / Number(totalPeriods))) / 100 +
            (totalToken * firstRe) / 100
        ) {
          checkClaim = 'Withdrawn';
        } else {
          if (
            Date.now() >=
            Number(startClaimTemp) * 1000 + Number(cliffTemp) * 1000
          ) {
            checkClaim = 'UnLocked';
          } else {
            checkClaim = 'Locked';
          }
        }
      } else {
        checkClaim = 'Locked';
      }
      let obj = {
        day: convertDateToString(Number(startClaimTemp) + Number(cliffTemp)),
        por: formatNumber((100 - firstRe) / Number(totalPeriods), 4),
        amount: formatNumber(
          (totalToken * ((100 - firstRe) / Number(totalPeriods))) / 100,
          4
        ),
        // totalToken / (Number(totalPeriods) + 1),
        asset: 'MEY',
        status: checkClaim,
      };
      arrvesting.push(obj);
    } else {
      let checkClaim: any;
      if (Date.now() >= Number(startClaimTemp) * 1000) {
        if (
          Number(totalClaimed) >=
          ((totalToken * ((100 - firstRe) / Number(totalPeriods))) / 100) *
            index +
            (totalToken * firstRe) / 100
        ) {
          checkClaim = 'Withdrawn';
        } else {
          if (
            Date.now() >=
            Number(startClaimTemp) * 1000 +
              Number(cliffTemp) * 1000 +
              Number(timePerPeriod * (index - 1)) * 1000
          ) {
            checkClaim = 'UnLocked';
          } else {
            checkClaim = 'Locked';
          }
        }
      } else {
        checkClaim = 'Locked';
      }
      let obj = {
        day: convertDateToString(
          Number(startClaimTemp) +
            Number(cliffTemp) +
            Number(timePerPeriod * (index - 1))
        ),
        por: formatNumber((100 - firstRe) / Number(totalPeriods), 4),
        amount: formatNumber(
          (totalToken * ((100 - firstRe) / Number(totalPeriods))) / 100,
          4
        ),
        // totalToken / (Number(totalPeriods) + 1),
        asset: 'MEY',
        status: checkClaim,
      };
      arrvesting.push(obj);
    }
  });

  const getLockedAmount = ({
    totalAmount,
    startTime = 0,
    firstReleasePercent = 0,
    cliffDuration = 0,
    totalPeriods = 0,
    timePerPeriod = 0,
    claimedAmount = 0,
  }: {
    totalAmount: any;
    startTime?: number;
    firstReleasePercent?: number;
    cliffDuration?: number;
    totalPeriods?: number;
    timePerPeriod?: number;
    claimedAmount?: number;
  }) => {
    const currentTime = Math.floor(Date.now() / 1000);
    const elapsed = currentTime - startTime;

    if (elapsed < 0) {
      return totalAmount - claimedAmount;
    }

    let unlocked = 0;

    // ✅ First release được unlock ngay tại startTime
    unlocked += (totalAmount * firstReleasePercent) / 100;

    const remaining = totalAmount * (1 - firstReleasePercent / 100);

    // ✅ Nếu đã qua thời gian cliff → tính số đợt đã bắt đầu (bao gồm cả đợt đang diễn ra)
    if (elapsed >= cliffDuration && totalPeriods > 0 && timePerPeriod > 0) {
      const timeAfterCliff = elapsed - cliffDuration;
      const periodsStarted = Math.floor(timeAfterCliff / timePerPeriod) + 1; // ✅ đợt vừa bắt đầu cũng được tính
      const actualPeriods = Math.min(periodsStarted, totalPeriods);

      unlocked += (remaining * actualPeriods) / totalPeriods;
    }

    const locked = Math.max(totalAmount - unlocked, 0);
    return locked;
  };

  const lockedAmount = useMemo(() => {
    const firstReleasePercent = Number(firstRelease || 0) / 100;
    return getLockedAmount({
      totalAmount: totalToken,
      startTime: startClaimTemp,
      firstReleasePercent: firstReleasePercent,
      cliffDuration: cliffTemp,
      totalPeriods: totalPeriods,
      timePerPeriod: timePerPeriod,
      claimedAmount: totalClaimed,
    });
  }, [
    totalToken,
    startClaimTemp,
    firstRelease,
    cliffTemp,
    totalPeriods,
    timePerPeriod,
  ]);

  // console.log('unlock token------------------------', unlockedToken);

  return (
    <>
      <div className="section-grow">
        <div className="container-vesting">
          <div className="content-vest">
            <div className="title-vest">MEY Token Vesting Contract</div>
            <div className="dec-vest">
              Withdraw your MEY tokens tokens from this vesting smart contract
            </div>
            <div className="list-item-vest">
              <div className="wrap-item-vest">
                <div className="item-vest">
                  <div className="item-vest1">
                    {formatNumber(totalToken, 5)} <span>MEY</span>
                  </div>
                  <div className="item-vest2">Total</div>
                </div>
              </div>
              <div className="wrap-item-vest">
                <div className="item-vest">
                  <div className="item-vest1">
                    {formatNumber(lockedAmount || 0, 5)}&nbsp;
                    <span>MEY</span>
                  </div>
                  <div className="item-vest2">Locked</div>
                </div>
              </div>
              <div className="wrap-item-vest">
                <div className="item-vest">
                  {timeNextClaim === 0 ? (
                    <>
                      <div className="item-vest1">Finished</div>
                    </>
                  ) : (
                    <>
                      {timeNextClaim && (
                        <div className="item-vest1">
                          <Countdown
                            date={timeNextClaim + 30000}
                            renderer={rendererCountDownVesting}
                          />
                          <div className="item-vest2">
                            Time until the next release
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="wrap-item-vest">
                <div className="item-vest">
                  <div className="item-vest1">
                    {formatNumber(totalClaimed, 5)} <span>MEY</span>
                  </div>
                  <div className="item-vest2">Claimed</div>
                </div>
              </div>
            </div>
            <div className="text-unlock">Unlocked Tokens</div>
            <div className="num-unlock">
              {formatNumber(unlockedToken, 5)} <span>MEY</span>
            </div>
            <div className="action-vest">
              <div className="view-sc" onClick={viewContract}>
                View vesting contract
              </div>

              {loading ? (
                <div {...btnWithdrawAll()}>
                  Waiting <div className="loader"></div>
                </div>
              ) : (
                <div {...btnWithdrawAll()} onClick={claim}>
                  Withdraw
                </div>
              )}
            </div>
          </div>
          <div className="content-vest">
            <div className="title-vest">Vesting Epochs</div>
            <div className="table-vest">
              {Number(totalToken) === 0 ? (
                <div className="box-no-data-stake">
                  <img
                    className="img-empty"
                    src="/images/no-data-cus.png"
                    alt=""
                  />
                </div>
              ) : (
                <>
                  <table cellSpacing="0" className="tb-vest">
                    <thead>
                      <tr className="tb-header">
                        <th>#</th>
                        <th>Date</th>
                        <th>Portion</th>
                        <th>Amount</th>
                        <th>Asset</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading1 ? (
                        <>
                          <tr className="tb-body" key={Math.random()}>
                            <td className="nodata" colSpan={6}>
                              <Skeleton paragraph={{ rows: 6 }} active />
                            </td>
                          </tr>
                        </>
                      ) : (
                        <>
                          {Number(totalToken) === 0 ? (
                            <tr className="tb-body" key={Math.random()}>
                              <td colSpan={6}>
                                <div className="box-no-data-stake">
                                  <img
                                    className="img-empty"
                                    src="/images/no-data-cus.png"
                                    alt=""
                                  />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {arrvesting.length > 0 ? (
                                <>
                                  {arrvesting.map((item: any, index: any) => (
                                    <tr className="tb-body" key={index}>
                                      <td>{index + 1}</td>
                                      <td>{item?.day}</td>
                                      <td className="text-blu">{item?.por}%</td>
                                      <td>{item?.amount}</td>
                                      <td>{item?.asset}</td>
                                      {item?.status === 'UnLocked' ? (
                                        <td className="unlocked">
                                          {item?.status}
                                        </td>
                                      ) : (
                                        <td>{item?.status}</td>
                                      )}
                                    </tr>
                                  ))}
                                </>
                              ) : (
                                <tr className="tb-body" key={Math.random()}>
                                  <td colSpan={6}>
                                    <div className="box-no-data-stake">
                                      <img
                                        className="img-empty"
                                        src="/images/no-data-cus.png"
                                        alt=""
                                      />
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vesting;
